import { useCallback } from 'react';
import Link from '@arivaa-react/components/link';
import { goToRoute } from '@arivaa-react/react-router5';
import { MailOutlined } from '@ant-design/icons';
import { ApiForm } from '../../../apiForm';
import { url } from '../../../../constants/api';
import { useVerificationData } from '../../useVerificationData';
import { isDemoEnabled } from '../../../../hooks/useAppConfig';
import { translate } from '../../../../localization';

/**
 * @description Forgot Form
 * @type Component
 * @author Inderdeep
 */

export const ForgotForm = () => {
  const { setVerificationData } = useVerificationData();
  /**
   * On Success of  Call
   * @param event
   */
  const onSuccess = useCallback(async ({ key, verificationCode }) => {
    setVerificationData({
      confirmationKey: key,
      confirmationType: 'email',
      verificationCode,
      api: 'password-reset/verify',
      apiConfig: {
        method: 'PATCH',
      },
      resendApi: 'password-reset/resend',
      onVerify: ({ token }, key) => {
        goToRoute('reset-password', {
          search: new URLSearchParams({
            type: 'email',
            key,
            token,
          }).toString(),
        });
      },
    });
    goToRoute('verify');
  }, []);
  return (
    <ApiForm
      elements={[
        {
          type: 'email',
          name: 'email',
          label: 'Email Address',
          required: true,
          options: {
            initialValue: isDemoEnabled ? 'admin@admin.com' : undefined,
          },
        },
      ]}
      apiUrl={url`password-reset`}
      submitButtonProps={{ children: 'Reset Password' }}
      successMessage={translate('forgot.success')}
      errorMessage={translate('forgot.error')}
      onSuccess={onSuccess}
    />
  );
};

export const ButtonLink = () => (
  <Link routeKey="forgot" routeParams={{ type: 'email' }}>
    <div className="auth-option">
      <span className="icon">
        <MailOutlined />
      </span>
      <p className="text">Email</p>
    </div>
  </Link>
);

export const Options = () => {
  return (
    <p className="option">
      Clicked by mistake?{' '}
      <Link routeKey="login" routeParams={{ type: 'email' }}>
        Login
      </Link>
    </p>
  );
};
